import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import SrBox from 'client/components/SrBox';
import './SrErrorMessage.less';

export const SR_ERROR_MESSAGE_THEME_ORANGE = 'SR_ERROR_MESSAGE_THEME_ORANGE';
export const SR_ERROR_MESSAGE_THEME_RED = 'SR_ERROR_MESSAGE_THEME_RED';
const SR_ERROR_MESSAGE_THEME_TO_CLASSNAME_MAPPING = {
  [SR_ERROR_MESSAGE_THEME_ORANGE]: 'message-orange',
  [SR_ERROR_MESSAGE_THEME_RED]: 'message-red',
};
const SR_ERROR_MESSAGE_THEMES = Object.keys(SR_ERROR_MESSAGE_THEME_TO_CLASSNAME_MAPPING);

const SrErrorMessage = ({ children, theme, ..._styles }) => (
  <SrBox
    styleName={classnames('formMessageError', SR_ERROR_MESSAGE_THEME_TO_CLASSNAME_MAPPING[theme])}
    {..._styles}
  >
    {children}
  </SrBox>
);

SrErrorMessage.propTypes = {
  ...SrBox.propTypes,
  theme: PropTypes.oneOf(SR_ERROR_MESSAGE_THEMES),
  children: PropTypes.node.isRequired,
};
SrErrorMessage.displayName = 'SrErrorMessage';

export default SrErrorMessage;
